import React from "react";

import { Button, SectionCard } from "shared/ui";

import { useTariffContext } from "features/Tariff/context";

import { Actions, Header, StatusBadge, TariffTitle } from "./styles";

export const CurrentTariffTab = () => {
    const state = useTariffContext();

    if (!state.tariff) return null;

    // В каталоге лежит и снятый с продажи тариф заведения — продлить можно любой свой.
    const currentPlan = state.tariffs.find((plan) => plan.id === state.tariff!.type) || null;

    return (
        <SectionCard title="Текущий тариф">
            <Header>
                <TariffTitle>{state.tariff.title}</TariffTitle>
                <StatusBadge $status={state.tariffStatus}>{state.tariffStatusText}</StatusBadge>
            </Header>

            {currentPlan && (
                <Actions>
                    {/* Продление открываем на месяце: продлевают обычно «на ещё немного». */}
                    <Button onClick={() => state.openPayment(currentPlan, "Month")}>
                        Продлить
                    </Button>
                </Actions>
            )}
        </SectionCard>
    );
};
